import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../common/hooks";
import { ReactComponent as WipImage } from "./wip.svg";
import "./wip.css";

export default function Wip() {
  const { theme } = useTheme();
  const { t } = useTranslation();
  return (
    <div className="wip-container">
      <WipImage className="wip-image" />
      <h1 className="wip-title" style={{ color: theme.primaryText }}>
        {t("wip.soon")}
      </h1>
    </div>
  );
}
